var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g2, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealthCare = function SvgHealthCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 564 523"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#HealthCare_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__b)",
    d: "M.646 261.5c0-57.4 18.51-110.476 49.885-153.587C88.963 55.105 146.7 17.248 213.373 4.719A262.7 262.7 0 0 1 261.932.214c144.305 0 261.286 116.981 261.286 261.286 0 62.351-21.84 119.601-58.287 164.518-47.905 59.038-121.046 96.768-202.999 96.768-26.453 0-51.988-3.931-76.052-11.241-67.006-20.354-122.611-66.903-154.893-127.725C11.62 347.326.647 305.695.647 261.5",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__c)",
    d: "M261.932 436.961c96.904 0 175.461-78.557 175.461-175.461S358.836 86.04 261.932 86.04 86.472 164.596 86.472 261.5s78.556 175.461 175.46 175.461",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__d)",
    d: "M261.932 372.829c61.485 0 111.329-49.844 111.329-111.329s-49.844-111.328-111.329-111.328S150.604 200.015 150.604 261.5s49.843 111.329 111.328 111.329",
    opacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9BEFF",
    d: "M261.932 437.607a.646.646 0 1 1 0-1.293c62.992 0 121.372-34.116 152.359-89.037a.647.647 0 0 1 1.127.635 177.06 177.06 0 0 1-63.373 64.926 175.2 175.2 0 0 1-42.594 18.283c-15.394 4.304-31.381 6.486-47.518 6.486zM411.891 170.999a.65.65 0 0 1-.553-.311c-13.834-22.711-32.995-42.286-55.413-56.608a.646.646 0 1 1 .696-1.09c22.583 14.428 41.884 34.147 55.821 57.026a.646.646 0 0 1-.551.983M523.205 264.84h-.007a.646.646 0 0 1-.64-.653q.013-1.342.013-2.687a.646.646 0 0 1 1.293 0q0 1.352-.014 2.701a.646.646 0 0 1-.646.64z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M394.842 487.152a.646.646 0 0 1-.33-1.203 272 272 0 0 0 4.578-2.774.647.647 0 0 1 .682 1.098c-1.516.94-3.063 1.878-4.6 2.788a.65.65 0 0 1-.329.09zm9.118-5.654a.645.645 0 0 1-.353-1.188c1.486-.965 2.987-1.96 4.458-2.958a.647.647 0 1 1 .726 1.071 263 263 0 0 1-4.48 2.973.64.64 0 0 1-.351.105zm8.877-6.021a.648.648 0 0 1-.374-1.175 260 260 0 0 0 4.334-3.138.647.647 0 0 1 .769 1.039 269 269 0 0 1-4.356 3.154.64.64 0 0 1-.373.12m8.625-6.381a.646.646 0 0 1-.396-1.159 263 263 0 0 0 4.202-3.314.648.648 0 0 1 .812 1.008 284 284 0 0 1-4.223 3.33.65.65 0 0 1-.395.135m8.357-6.73a.645.645 0 0 1-.416-1.142 258 258 0 0 0 4.064-3.483.646.646 0 1 1 .851.973 266 266 0 0 1-4.084 3.5.65.65 0 0 1-.415.151zm8.076-7.064a.646.646 0 0 1-.436-1.125 265 265 0 0 0 3.919-3.646.646.646 0 1 1 .89.937 262 262 0 0 1-3.937 3.665.65.65 0 0 1-.436.169m7.781-7.391a.647.647 0 0 1-.455-1.107c1.265-1.25 2.532-2.53 3.767-3.803a.647.647 0 0 1 .928.901 262 262 0 0 1-3.786 3.822.64.64 0 0 1-.455.187zm7.474-7.701a.647.647 0 0 1-.473-1.088 260 260 0 0 0 3.61-3.954.647.647 0 0 1 .963.863c-1.19 1.33-2.41 2.667-3.626 3.974a.65.65 0 0 1-.473.206zm7.154-8a.646.646 0 0 1-.49-1.068 269 269 0 0 0 3.444-4.098.646.646 0 0 1 .999.82 272 272 0 0 1-3.462 4.12.65.65 0 0 1-.491.225zm6.823-8.287a.647.647 0 0 1-.508-1.048 273 273 0 0 0 3.275-4.236.647.647 0 0 1 1.031.781 274 274 0 0 1-3.291 4.258.64.64 0 0 1-.507.245m6.477-8.56a.646.646 0 0 1-.523-1.026 268 268 0 0 0 3.099-4.367.648.648 0 0 1 1.062.738 277 277 0 0 1-3.114 4.388.65.65 0 0 1-.524.267m6.122-8.818a.647.647 0 0 1-.538-1.005c.983-1.48 1.965-2.991 2.917-4.49a.647.647 0 1 1 1.092.693 256 256 0 0 1-2.932 4.513.65.65 0 0 1-.539.29zm5.757-9.064a.647.647 0 0 1-.551-.982c.922-1.52 1.84-3.07 2.73-4.606a.647.647 0 1 1 1.119.648 251 251 0 0 1-2.745 4.629.64.64 0 0 1-.554.312zm5.379-9.292a.645.645 0 0 1-.565-.959 263 263 0 0 0 2.539-4.716.646.646 0 1 1 1.145.6 276 276 0 0 1-2.551 4.739.65.65 0 0 1-.566.335zm4.993-9.507a.645.645 0 0 1-.577-.936 267 267 0 0 0 2.342-4.817.647.647 0 0 1 1.169.554 263 263 0 0 1-2.354 4.841.65.65 0 0 1-.579.358zm4.597-9.707a.7.7 0 0 1-.265-.056c-.325-.146-.472-.529-.325-.854a262 262 0 0 0 2.142-4.911.647.647 0 0 1 1.191.504 264 264 0 0 1-2.152 4.936.65.65 0 0 1-.59.381zm4.192-9.886a.646.646 0 0 1-.6-.887 255 255 0 0 0 1.935-4.991.646.646 0 1 1 1.21.455 262 262 0 0 1-1.945 5.016.645.645 0 0 1-.601.407zm3.778-10.047a.648.648 0 0 1-.61-.861 256 256 0 0 0 1.727-5.067.647.647 0 0 1 1.228.404 263 263 0 0 1-1.736 5.092.65.65 0 0 1-.61.432zm3.358-10.195a.647.647 0 0 1-.619-.836 263 263 0 0 0 1.517-5.135.647.647 0 0 1 1.244.355 256 256 0 0 1-1.525 5.159.65.65 0 0 1-.618.457zm2.934-10.324a.647.647 0 0 1-.626-.811 264 264 0 0 0 1.303-5.192.647.647 0 0 1 1.257.301c-.418 1.74-.858 3.495-1.309 5.219a.65.65 0 0 1-.625.483m2.504-10.437a.647.647 0 0 1-.633-.784c.38-1.739.744-3.503 1.086-5.242a.646.646 0 1 1 1.269.248 259 259 0 0 1-1.092 5.269.645.645 0 0 1-.63.509m2.07-10.532a.646.646 0 0 1-.638-.758c.306-1.746.599-3.523.87-5.284a.645.645 0 1 1 1.278.197 267 267 0 0 1-.874 5.309.645.645 0 0 1-.636.535zm1.635-10.609a.648.648 0 0 1-.642-.732c.234-1.76.454-3.548.652-5.314a.647.647 0 1 1 1.285.144 258 258 0 0 1-.655 5.34.646.646 0 0 1-.64.562m1.198-10.667q-.03 0-.06-.002a.647.647 0 0 1-.586-.702c.163-1.769.309-3.565.434-5.336a.64.64 0 0 1 .69-.599.644.644 0 0 1 .599.69 260 260 0 0 1-.436 5.363.647.647 0 0 1-.643.588zm.759-10.708h-.033a.647.647 0 0 1-.614-.679c.09-1.776.162-3.576.216-5.349a.647.647 0 0 1 1.294.039 262 262 0 0 1-.218 5.377.646.646 0 0 1-.645.613z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9BEFF",
    d: "M387.866 491.138a.646.646 0 0 1-.311-1.213 269 269 0 0 0 2.347-1.309.645.645 0 1 1 .635 1.126 302 302 0 0 1-2.359 1.316.64.64 0 0 1-.312.081zM143.576 495.152a.64.64 0 0 1-.292-.071 271 271 0 0 1-2.401-1.237.647.647 0 0 1 .599-1.146q1.19.621 2.389 1.231a.647.647 0 0 1-.294 1.224z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M136.486 491.406a.65.65 0 0 1-.311-.08 265 265 0 0 1-4.656-2.616.645.645 0 1 1 .644-1.12c1.532.882 3.091 1.758 4.633 2.603a.647.647 0 0 1-.312 1.214zm-9.236-5.313a.65.65 0 0 1-.333-.092 266 266 0 0 1-4.546-2.803.647.647 0 1 1 .69-1.094c1.49.94 3.012 1.879 4.523 2.79a.646.646 0 0 1-.334 1.2zm-9.011-5.685a.65.65 0 0 1-.356-.107 263 263 0 0 1-4.427-2.986.647.647 0 1 1 .734-1.065c1.447.998 2.929 1.998 4.405 2.971a.647.647 0 0 1-.357 1.187zm-8.771-6.046a.65.65 0 0 1-.377-.121 259 259 0 0 1-4.301-3.164.646.646 0 1 1 .776-1.033 269 269 0 0 0 4.282 3.148.648.648 0 0 1-.379 1.172zm-8.517-6.397a.64.64 0 0 1-.399-.138 261 261 0 0 1-4.17-3.335.647.647 0 0 1 .818-1.002 264 264 0 0 0 4.149 3.319c.282.22.331.627.11.907a.64.64 0 0 1-.509.248zm-8.251-6.737a.65.65 0 0 1-.419-.154 270 270 0 0 1-4.031-3.501.648.648 0 0 1 .858-.968c1.32 1.17 2.67 2.342 4.01 3.484a.646.646 0 0 1-.42 1.139zm-7.97-7.065a.65.65 0 0 1-.44-.171c-1.299-1.2-2.607-2.432-3.885-3.661a.646.646 0 1 1 .896-.932 264 264 0 0 0 3.867 3.643.646.646 0 0 1-.439 1.122zm-7.678-7.383a.65.65 0 0 1-.457-.189 277 277 0 0 1-3.735-3.815.647.647 0 1 1 .933-.895 274 274 0 0 0 3.716 3.797.647.647 0 0 1-.457 1.103zm-7.37-7.687a.65.65 0 0 1-.477-.208c-1.198-1.3-2.4-2.633-3.576-3.963a.647.647 0 1 1 .969-.856c1.17 1.322 2.367 2.65 3.558 3.943a.647.647 0 0 1-.475 1.085zm-7.055-7.978a.64.64 0 0 1-.493-.229 264 264 0 0 1-3.412-4.104.647.647 0 0 1 1.003-.816 266 266 0 0 0 3.395 4.084.647.647 0 0 1-.492 1.065m-6.724-8.258a.65.65 0 0 1-.51-.248 264 264 0 0 1-3.243-4.24.647.647 0 0 1 1.034-.775 266 266 0 0 0 3.227 4.219.646.646 0 0 1-.51 1.044zm-6.383-8.523a.64.64 0 0 1-.526-.269 266 266 0 0 1-3.068-4.367.647.647 0 0 1 1.066-.733 255 255 0 0 0 3.053 4.346.646.646 0 0 1-.524 1.023zm-6.031-8.773a.64.64 0 0 1-.54-.292 265 265 0 0 1-2.888-4.488.648.648 0 0 1 1.094-.689 263 263 0 0 0 2.873 4.466.646.646 0 0 1-.539 1.002zm-5.67-9.013a.64.64 0 0 1-.554-.314 262 262 0 0 1-2.702-4.602.647.647 0 1 1 1.121-.643 271 271 0 0 0 2.688 4.579.647.647 0 0 1-.552.979zm-5.297-9.236a.65.65 0 0 1-.568-.336l-.338-.623a270 270 0 0 1-2.174-4.086.647.647 0 1 1 1.147-.598 258 258 0 0 0 2.162 4.066l.338.619a.646.646 0 0 1-.566.957zm-4.916-9.444a.65.65 0 0 1-.58-.36 265 265 0 0 1-2.318-4.807.647.647 0 1 1 1.17-.549 262 262 0 0 0 2.307 4.783.646.646 0 0 1-.578.933zm-4.526-9.638a.65.65 0 0 1-.591-.383 269 269 0 0 1-2.119-4.899.646.646 0 1 1 1.192-.501 265 265 0 0 0 2.109 4.875.647.647 0 0 1-.59.91zm-4.126-9.814a.645.645 0 0 1-.601-.409 257 257 0 0 1-1.916-4.98.647.647 0 0 1 1.211-.453 255 255 0 0 0 1.907 4.956.647.647 0 0 1-.601.886m-3.72-9.974a.65.65 0 0 1-.61-.434 266 266 0 0 1-1.71-5.055.646.646 0 1 1 1.227-.401 269 269 0 0 0 1.701 5.03.648.648 0 0 1-.61.86zm-3.308-10.119a.65.65 0 0 1-.618-.458 261 261 0 0 1-1.5-5.12.648.648 0 0 1 1.244-.351c.479 1.696.982 3.411 1.494 5.095a.648.648 0 0 1-.618.835zm-2.89-10.244a.646.646 0 0 1-.625-.484c-.446-1.716-.88-3.458-1.289-5.178a.647.647 0 1 1 1.259-.299c.407 1.711.838 3.445 1.283 5.151a.645.645 0 0 1-.626.81zm-2.467-10.354a.65.65 0 0 1-.631-.51 264 264 0 0 1-1.076-5.225.646.646 0 1 1 1.27-.247c.337 1.729.697 3.478 1.07 5.2a.646.646 0 0 1-.633.783zM4.53 307.28a.65.65 0 0 1-.636-.536 264 264 0 0 1-.86-5.264.646.646 0 1 1 1.278-.196c.267 1.742.555 3.505.857 5.238a.647.647 0 0 1-.637.758zm-1.61-10.519a.65.65 0 0 1-.641-.562c-.232-1.755-.45-3.537-.646-5.294a.648.648 0 0 1 1.285-.144c.195 1.748.412 3.521.643 5.268a.647.647 0 0 1-.641.732m-1.181-10.575a.646.646 0 0 1-.643-.587 269 269 0 0 1-.431-5.316.646.646 0 0 1 1.289-.091c.125 1.758.269 3.538.429 5.29a.645.645 0 0 1-.586.702q-.03.002-.06.002zm-.752-10.612a.646.646 0 0 1-.646-.614 270 270 0 0 1-.216-5.328.646.646 0 0 1 .626-.666.653.653 0 0 1 .667.627c.054 1.761.126 3.546.215 5.302a.65.65 0 0 1-.614.679H.984z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9BEFF",
    d: "M.66 264.841a.646.646 0 0 1-.646-.641Q0 262.852 0 261.499a.646.646 0 1 1 1.292 0q0 1.345.014 2.687a.646.646 0 0 1-.64.653H.658z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7892FF",
    d: "M521.233 239.872a41.9 41.9 0 0 1-16.429-3.317 42.1 42.1 0 0 1-13.417-9.046 42 42 0 0 1-9.046-13.417 41.95 41.95 0 0 1-3.318-16.429 41.9 41.9 0 0 1 3.318-16.43 42.1 42.1 0 0 1 9.046-13.417 42.05 42.05 0 0 1 13.417-9.045 41.95 41.95 0 0 1 16.429-3.318 41.9 41.9 0 0 1 16.43 3.318 42.1 42.1 0 0 1 13.417 9.045 42.1 42.1 0 0 1 9.045 13.417 42 42 0 0 1 3.318 16.43 41.9 41.9 0 0 1-3.318 16.429 42.1 42.1 0 0 1-9.045 13.417 42.1 42.1 0 0 1-13.417 9.046 42 42 0 0 1-16.43 3.317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49FBDF",
    d: "M521.233 156.011c23.004 0 41.652 18.649 41.652 41.653s-18.648 41.652-41.652 41.652-41.653-18.648-41.653-41.652 18.649-41.653 41.653-41.653m0-1.114a42.5 42.5 0 0 0-16.647 3.362 42.6 42.6 0 0 0-13.594 9.164 42.7 42.7 0 0 0-9.165 13.594 42.5 42.5 0 0 0-3.361 16.647 42.5 42.5 0 0 0 3.361 16.647 42.6 42.6 0 0 0 9.165 13.593 42.6 42.6 0 0 0 13.594 9.165 42.5 42.5 0 0 0 16.647 3.362 42.5 42.5 0 0 0 16.646-3.362 42.6 42.6 0 0 0 13.594-9.165 42.6 42.6 0 0 0 9.165-13.593A42.5 42.5 0 0 0 564 197.664a42.5 42.5 0 0 0-3.362-16.647 42.6 42.6 0 0 0-9.165-13.594 42.6 42.6 0 0 0-13.594-9.164 42.5 42.5 0 0 0-16.646-3.362"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__e)",
    d: "m549.118 201.475-4.898 4.977-22.817 23.156-22.817-23.156-4.899-4.977c-3.568-3.545-5.496-8.703-4.566-14.332 1.055-6.387 6.022-11.66 12.342-13.057 5.78-1.278 11.314.559 15.041 4.234l.677.677.06.059 4.162 4.241 4.162-4.241.059-.059.677-.677c3.726-3.675 9.26-5.512 15.041-4.234 6.32 1.397 11.288 6.671 12.342 13.057.93 5.629-.997 10.787-4.566 14.332"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#49FBDF",
    d: "M557.6 195.013a3.996 3.996 0 0 0-3.919 3.248h-15.455l-4.418-12.344a.743.743 0 0 0-1.371-.071l-9.869 20.596-4.614-17.199a.743.743 0 0 0-1.377-.154l-4.833 9.173h-13.882a.744.744 0 1 0 0 1.489h14.331a.75.75 0 0 0 .658-.398l4.157-7.892 4.644 17.307a.744.744 0 0 0 1.389.129l9.967-20.799 3.994 11.159a.74.74 0 0 0 .7.494h15.979a4 4 0 0 0 3.919 3.247 3.996 3.996 0 0 0 3.991-3.992c0-2.2-1.791-3.99-3.991-3.99zm0 6.496a2.507 2.507 0 0 1-2.504-2.505 2.507 2.507 0 0 1 2.504-2.504 2.51 2.51 0 0 1 2.504 2.504 2.51 2.51 0 0 1-2.504 2.505M485.401 198.261h-9.478a.744.744 0 1 0 0 1.488h9.478a.744.744 0 1 0 0-1.488"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__f)",
    d: "M60.925 300.336c25.977 0 47.035-21.059 47.035-47.036s-21.058-47.036-47.035-47.036c-25.978 0-47.036 21.059-47.036 47.036s21.058 47.036 47.036 47.036"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M99.072 253.301a38.2 38.2 0 0 1-9.734 25.524l-4.71-4.716-.042-.042a31.4 31.4 0 0 0 7.764-19.55c.652-17.103-12.437-31.544-29.405-32.679v-6.787c20.14 1.118 36.127 17.814 36.127 38.251z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF3FE",
    d: "M29.335 251.104c1.078-15.681 13.589-28.21 29.262-29.318v-6.69a38.13 38.13 0 0 0-24.842 11.145 38.2 38.2 0 0 0-11.137 24.862h6.717zM62.944 284.827a31.45 31.45 0 0 0 18.634-7.679l4.717 4.722c-6.272 5.611-14.4 9.185-23.35 9.682zM58.64 284.817c-15.707-1.087-28.25-13.648-29.309-29.363h-6.758c1.076 19.444 16.64 35.019 36.068 36.096z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M76.616 246.971H67.26v-9.356H54.562v9.356h-9.356v12.698h9.356v9.355H67.26v-9.355h9.356z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__g)",
    d: "M346.157 522.736c23.004 0 41.653-18.648 41.653-41.652s-18.649-41.652-41.653-41.652-41.652 18.648-41.652 41.652 18.648 41.652 41.652 41.652"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF3FE",
    d: "M334.396 460.935h14.28a23 23 0 0 0-.438-.948c-1.866-3.798-4.309-5.977-6.703-5.977-2.393 0-4.836 2.179-6.703 5.977q-.225.463-.437.948zM335.885 453.043a23.57 23.57 0 0 0-12.529 7.892h7.474c1.295-3.388 3.029-6.109 5.054-7.892zM330.831 490.894h-7.476a23.57 23.57 0 0 0 12.529 7.892c-2.025-1.782-3.759-4.503-5.053-7.892M333.004 464.044c-1.032 3.475-1.584 7.482-1.584 11.678s.553 8.204 1.584 11.678h16.678c1.033-3.474 1.584-7.482 1.584-11.678s-.553-8.203-1.584-11.678zM348.675 490.894h-14.28q.21.486.437.948c1.867 3.798 4.31 5.977 6.703 5.977s4.837-2.179 6.703-5.977q.226-.464.438-.948zM347.188 498.785c1.062-.263 2.1-.597 3.101-.998v-2.833c-.924 1.539-1.966 2.833-3.101 3.829zM347.186 453.043c2.025 1.783 3.759 4.504 5.053 7.892h7.474a23.57 23.57 0 0 0-12.528-7.892zM328.31 475.914c0-4.24.523-8.204 1.455-11.677h-8.691a23.44 23.44 0 0 0-3.095 11.677c0 4.25 1.126 8.235 3.095 11.678h8.691c-.932-3.473-1.455-7.437-1.455-11.678M353.921 483.666a12.1 12.1 0 0 1 10.258-5.027c.177.007.359.016.534.028q.183-1.45.183-2.945c0-4.249-1.125-8.235-3.095-11.677h-8.689c.931 3.472 1.456 7.436 1.456 11.677a48 48 0 0 1-.647 7.944"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#75FADE",
    d: "M372.808 492.715v-1.743c0-4.779-3.809-8.682-8.546-8.841q-.15-.004-.299-.005c-3.683 0-6.846 2.261-8.176 5.466a8.8 8.8 0 0 0-.671 3.302v1.821a1.98 1.98 0 0 0-1.525 1.927v12.499c0 1.094.887 1.981 1.981 1.981h16.783a1.98 1.98 0 0 0 1.982-1.981v-12.499c0-.938-.653-1.722-1.528-1.928zm-7.525 10.476a1.32 1.32 0 0 1-2.641 0v-5.038a1.32 1.32 0 1 1 2.641 0zm4.223-10.53h-11.089v-1.689q0-.038.002-.077a5.5 5.5 0 0 1 1.152-3.302 5.55 5.55 0 0 1 4.393-2.164 5.55 5.55 0 0 1 5.543 5.544v1.69z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__h)",
    d: "M205.098 95.629H96.53a7.084 7.084 0 0 0-7.085 7.084v20.35a7.084 7.084 0 0 0 7.085 7.084h108.568a7.084 7.084 0 0 0 7.084-7.084v-20.35a7.084 7.084 0 0 0-7.084-7.084",
    opacity: 0.25
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5B5F2",
    d: "m112.1 116.313-1.304-.917 1.973-3.276-3.347-1.373.458-1.479 3.559.916.317-3.769h1.55l.318 3.734 3.522-.88.493 1.479-3.347 1.374 1.973 3.276-1.304.916-2.395-2.995zM126.613 116.313l-1.304-.917 1.972-3.276-3.346-1.373.458-1.479 3.558.916.318-3.769h1.55l.317 3.734 3.523-.88.493 1.479-3.347 1.374 1.973 3.276-1.304.916-2.396-2.995zM141.126 116.313l-1.303-.917 1.972-3.276-3.347-1.373.458-1.479 3.559.916.317-3.769h1.551l.317 3.734 3.523-.88.493 1.479-3.347 1.374 1.972 3.276-1.303.916-2.396-2.995zM155.641 116.313l-1.304-.917 1.973-3.276-3.347-1.373.458-1.479 3.559.916.317-3.769h1.55l.318 3.734 3.522-.88.493 1.479-3.347 1.374 1.973 3.276-1.304.916-2.395-2.995zM170.155 116.313l-1.304-.917 1.972-3.276-3.346-1.373.458-1.479 3.558.916.318-3.769h1.55l.317 3.734 3.523-.88.493 1.479-3.347 1.374 1.972 3.276-1.303.916-2.396-2.995zM184.667 116.313l-1.303-.917 1.972-3.276-3.347-1.373.458-1.479 3.559.916.317-3.769h1.551l.317 3.734 3.523-.88.493 1.479-3.347 1.374 1.972 3.276-1.303.916-2.396-2.995z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__i)",
    d: "M428.467 268.043v10.361c0 5.559 1.739 10.968 4.918 15.353 1.697-3.631 6.269-6.232 11.644-6.232 5.376 0 9.947 2.601 11.644 6.232 3.179-4.386 4.918-9.795 4.918-15.353v-10.361c-5.922-3.051-14.971-4.633-16.562-4.895-1.592.261-10.641 1.844-16.562 4.895m22.981 9.444c-.246 3.122-2.775 5.65-5.897 5.897a6.442 6.442 0 0 1-6.941-6.943c.247-3.122 2.775-5.65 5.897-5.897a6.442 6.442 0 0 1 6.941 6.943"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__j)",
    d: "m467.415 262.528-1.219-.695c-7.497-4.268-18.979-6.097-20.263-6.291l-.361-.055a3.7 3.7 0 0 0-1.086 0l-.361.055c-1.285.195-12.766 2.024-20.263 6.291l-1.219.695a3.62 3.62 0 0 0-1.831 3.148v12.728c0 7.658 2.574 15.114 7.246 20.992a33 33 0 0 0 3.298 3.567 32.1 32.1 0 0 0 11.759 6.992l1.153.386c.494.166 1.03.166 1.524 0l1.153-.386a32.1 32.1 0 0 0 11.76-6.994 33 33 0 0 0 3.296-3.565c4.673-5.88 7.247-13.335 7.247-20.993v-12.728a3.62 3.62 0 0 0-1.831-3.148zm-2.589 15.876c0 6.664-2.233 13.141-6.287 18.242a28 28 0 0 1-2.848 3.082 27.7 27.7 0 0 1-10.149 6.035 1.6 1.6 0 0 1-1.026 0 27.7 27.7 0 0 1-10.149-6.035 28 28 0 0 1-2.85-3.083c-4.053-5.1-6.286-11.578-6.286-18.241v-11.325c0-.581.312-1.118.817-1.405 6.919-3.939 18.258-5.689 18.738-5.763q.243-.036.484 0c.479.072 11.818 1.823 18.737 5.763.506.287.818.824.818 1.405v11.325z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__k)",
    d: "M141.794 394.708v6.707c0 3.047 7.195 5.517 16.071 5.517s16.072-2.47 16.072-5.517v-6.707z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__l)",
    d: "M157.865 400.224c8.876 0 16.072-2.469 16.072-5.516 0-3.046-7.196-5.516-16.072-5.516s-16.071 2.47-16.071 5.516c0 3.047 7.195 5.516 16.071 5.516"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__m)",
    d: "M141.794 384.874v6.707c0 3.046 7.195 5.516 16.071 5.516s16.072-2.47 16.072-5.516v-6.707z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__n)",
    d: "M157.865 390.389c8.876 0 16.072-2.469 16.072-5.516 0-3.046-7.196-5.516-16.072-5.516s-16.071 2.47-16.071 5.516c0 3.047 7.195 5.516 16.071 5.516"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__o)",
    d: "M141.794 375.039v6.707c0 3.046 7.195 5.516 16.071 5.516s16.072-2.47 16.072-5.516v-6.707z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__p)",
    d: "M157.865 380.555c8.876 0 16.072-2.47 16.072-5.516 0-3.047-7.196-5.517-16.072-5.517s-16.071 2.47-16.071 5.517c0 3.046 7.195 5.516 16.071 5.516"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__q)",
    d: "M124.021 405.466v6.708c0 3.046 7.195 5.516 16.072 5.516s16.071-2.47 16.071-5.516v-6.708h-32.143"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__r)",
    d: "M140.093 410.982c8.876 0 16.071-2.469 16.071-5.516s-7.195-5.516-16.071-5.516-16.072 2.469-16.072 5.516 7.196 5.516 16.072 5.516"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__s)",
    d: "M124.021 395.631v6.708c0 3.046 7.195 5.516 16.072 5.516s16.071-2.47 16.071-5.516v-6.708h-32.143"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__t)",
    d: "M140.093 401.148c8.876 0 16.071-2.47 16.071-5.516 0-3.047-7.195-5.517-16.071-5.517s-16.072 2.47-16.072 5.517c0 3.046 7.196 5.516 16.072 5.516"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__u)",
    d: "M124.021 385.797v6.707c0 3.047 7.195 5.516 16.072 5.516s16.071-2.469 16.071-5.516v-6.707h-32.143"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__v)",
    d: "M140.093 391.313c8.876 0 16.071-2.47 16.071-5.516 0-3.047-7.195-5.517-16.071-5.517s-16.072 2.47-16.072 5.517c0 3.046 7.196 5.516 16.072 5.516"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBFE",
    d: "M157.351 405.208c5.472 0 9.908-4.436 9.908-9.908s-4.436-9.907-9.908-9.907-9.908 4.436-9.908 9.907c0 5.472 4.436 9.908 9.908 9.908"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__w)",
    d: "M161.572 392.867h-8.443a.995.995 0 0 0-.996.996v6.289c0 .55.446.996.996.996h8.443a.996.996 0 0 0 .997-.996v-6.289a.996.996 0 0 0-.997-.996m-5.818 1.595a.945.945 0 1 1 0 1.89.945.945 0 0 1 0-1.89m3.166 5.092a.945.945 0 1 1 .003-1.89.945.945 0 0 1-.003 1.89m.009-3.194a1 1 0 0 1-.339-.063l-1.977 1.966a.944.944 0 1 1-.552-.54l1.985-1.973a.946.946 0 0 1 .883-1.278.946.946 0 0 1 0 1.889z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__x)",
    d: "M160.971 394.154a.644.644 0 0 1-.644-.644v-1.28a2.98 2.98 0 0 0-2.976-2.976 2.98 2.98 0 0 0-2.975 2.976v1.28a.644.644 0 0 1-1.288 0v-1.28a4.27 4.27 0 0 1 4.263-4.264 4.27 4.27 0 0 1 4.263 4.264v1.28a.644.644 0 0 1-.643.644"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__y)",
    d: "M306.452 73.873h-5.419v-5.418c0-1.03-.835-1.865-1.865-1.865h-3.944a1.864 1.864 0 0 0-1.865 1.865v5.418h-5.418c-1.03 0-1.866.836-1.866 1.866v3.943a1.866 1.866 0 0 0 1.866 1.866h5.418v5.418c0 1.03.835 1.866 1.865 1.866h3.944c1.03 0 1.865-.836 1.865-1.866v-5.418h5.419c1.03 0 1.865-.836 1.865-1.866V75.74c0-1.03-.835-1.866-1.865-1.866"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__z)",
    d: "m317.231 59.457 2.673 9.979a.7.7 0 0 1 .022.297c.01.01 0 .01 0 .01a.912.912 0 0 1-1.143.814l-5.726-1.537-4.247-1.142a.91.91 0 0 1-.41-1.526l1.525-1.525c-7.123-7.124-18.713-7.124-25.837 0a18.2 18.2 0 0 0-2.553 3.2 18.3 18.3 0 0 0-2.622 7.223c-.209 1.509-1.453 2.656-2.975 2.656h-.022c-1.823 0-3.21-1.614-2.968-3.42a24.17 24.17 0 0 1 6.886-13.911c9.468-9.47 24.876-9.47 34.343 0l1.521-1.521a.915.915 0 0 1 1.531.404z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__A)",
    d: "M318.497 77.905c1.822 0 3.205 1.623 2.938 3.424a24.17 24.17 0 0 1-6.838 13.588c-9.468 9.469-24.876 9.469-34.343 0l-1.521 1.521a.915.915 0 0 1-1.531-.404l-2.674-9.979a.7.7 0 0 1-.022-.297.91.91 0 0 1 1.143-.824l5.726 1.537 4.247 1.142a.91.91 0 0 1 .41 1.526l-1.525 1.525c7.124 7.124 18.713 7.124 25.837 0a18.2 18.2 0 0 0 5.142-10.167c.224-1.477 1.45-2.592 2.945-2.592z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__B)",
    d: "m374.472 355.287-18.312-4.74a.675.675 0 0 0-.823.822l4.741 18.312a.675.675 0 0 0 1.218.201l2.372-3.631a.675.675 0 0 1 1.043-.108l8.658 8.658a.675.675 0 0 0 .955 0l5.267-5.267a.677.677 0 0 0 0-.955l-8.658-8.658a.676.676 0 0 1 .108-1.043l3.63-2.372a.674.674 0 0 0-.2-1.218z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M75.551 316.708H54.96v3.24h20.591zM92.973 316.708H80.968v3.24h12.005zM90.572 325.215H54.96v3.24h35.612zM107.993 325.215H95.987v3.24h12.006zM80.966 333.722H54.96v3.24h26.006zM107.992 333.722h-21.61v3.24h21.61zM89.607 342.229H54.96v3.239h34.647zM107.029 342.229H95.023v3.239h12.006z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#204969",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.622 116.298H426.03v3.24h20.592zM464.042 116.298h-12.005v3.24h12.005zM461.642 124.805H426.03v3.24h35.612zM479.063 124.805h-12.005v3.24h12.005zM452.037 133.311H426.03v3.24h26.007zM479.062 133.311h-21.609v3.24h21.609zM460.677 141.817H426.03v3.24h34.647zM478.098 141.817h-12.005v3.24h12.005z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD5FC",
    d: "M152.841 434.953v-.881h2.124v-7.008h-1.676v-.679a6.3 6.3 0 0 0 1.084-.267q.462-.166.838-.383h.809v8.338h1.922v.881h-5.101zM162.203 435.127q-1.359 0-2.131-1.25-.773-1.25-.773-3.562c0-1.541.258-2.731.773-3.54q.774-1.214 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.532t-.766 3.562q-.767 1.25-2.138 1.25m0-.853q.564 0 .99-.418.426-.419.657-1.301t.231-2.239c0-.905-.078-1.659-.231-2.232q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404 1.37 1.37 0 0 0-.982.404q-.42.405-.658 1.264-.239.86-.239 2.232c0 .916.079 1.653.239 2.239q.238.882.658 1.301.418.418.982.418M166.466 434.953v-.881h2.124v-7.008h-1.676v-.679a6.3 6.3 0 0 0 1.084-.267q.462-.166.838-.383h.809v8.338h1.922v.881h-5.101zM175.829 435.127q-1.359 0-2.131-1.25-.773-1.25-.773-3.562c0-1.541.258-2.731.773-3.54q.774-1.214 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.532t-.766 3.562q-.767 1.25-2.138 1.25m0-.853q.564 0 .99-.418.426-.419.657-1.301t.231-2.239c0-.905-.078-1.659-.231-2.232q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404q-.563 0-.983.404-.418.405-.657 1.264-.239.86-.239 2.232c0 .916.079 1.653.239 2.239q.238.882.657 1.301t.983.418M180.093 434.953v-.881h2.124v-7.008h-1.676v-.679a6.3 6.3 0 0 0 1.084-.267q.463-.166.838-.383h.809v8.338h1.922v.881h-5.101zM189.455 435.127q-1.359 0-2.131-1.25-.773-1.25-.773-3.562c0-1.541.258-2.731.773-3.54q.774-1.214 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.532t-.766 3.562-2.138 1.25m0-.853q.564 0 .99-.418.426-.419.657-1.301t.231-2.239c0-.905-.078-1.659-.231-2.232q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404q-.563 0-.983.404-.418.405-.657 1.264-.239.86-.239 2.232c0 .916.079 1.653.239 2.239q.238.882.657 1.301t.983.418M152.841 452.293v-.882h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.462-.166.838-.382h.809v8.337h1.922v.882zM162.203 452.466q-1.359 0-2.131-1.25-.773-1.25-.773-3.561c0-1.542.258-2.732.773-3.541q.774-1.214 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.533t-.766 3.561q-.767 1.25-2.138 1.25m0-.852q.564 0 .99-.419t.657-1.3q.232-.882.231-2.239c0-.905-.078-1.66-.231-2.233q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404 1.37 1.37 0 0 0-.982.404q-.42.405-.658 1.264-.239.86-.239 2.233c0 .915.079 1.652.239 2.239q.238.881.658 1.3.418.419.982.419M166.466 452.293v-.882h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.462-.166.838-.382h.809v8.337h1.922v.882zM175.829 452.466q-1.359 0-2.131-1.25-.773-1.25-.773-3.561c0-1.542.258-2.732.773-3.541q.774-1.214 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.533t-.766 3.561q-.767 1.25-2.138 1.25m0-.852q.564 0 .99-.419t.657-1.3.231-2.239c0-.905-.078-1.66-.231-2.233q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404q-.563 0-.983.404-.418.405-.657 1.264-.239.86-.239 2.233c0 .915.079 1.652.239 2.239q.238.881.657 1.3t.983.419M180.093 452.293v-.882h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.463-.166.838-.382h.809v8.337h1.922v.882zM189.455 452.466q-1.359 0-2.131-1.25-.773-1.25-.773-3.561c0-1.542.258-2.732.773-3.541q.774-1.214 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.533t-.766 3.561q-.767 1.25-2.138 1.25m0-.852q.564 0 .99-.419t.657-1.3.231-2.239c0-.905-.078-1.66-.231-2.233q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404q-.563 0-.983.404-.418.405-.657 1.264-.239.86-.239 2.233c0 .915.079 1.652.239 2.239q.238.881.657 1.3t.983.419M193.718 452.293v-.882h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.463-.166.838-.382h.809v8.337h1.922v.882zM152.841 469.631v-.881h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.462-.166.838-.382h.809v8.337h1.922v.882h-5.101zM162.203 469.805q-1.359 0-2.131-1.25-.773-1.25-.773-3.562c0-1.541.258-2.731.773-3.54q.774-1.215 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.532t-.766 3.562q-.767 1.25-2.138 1.25m0-.852q.564 0 .99-.419t.657-1.3q.232-.882.231-2.24c0-.905-.078-1.659-.231-2.232q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404 1.37 1.37 0 0 0-.982.404q-.42.405-.658 1.264-.239.86-.239 2.232c0 .916.079 1.653.239 2.24q.238.881.658 1.3.418.419.982.419M166.466 469.631v-.881h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.462-.166.838-.382h.809v8.337h1.922v.882h-5.101zM175.829 469.805q-1.359 0-2.131-1.25-.773-1.25-.773-3.562c0-1.541.258-2.731.773-3.54q.774-1.215 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.532t-.766 3.562q-.767 1.25-2.138 1.25m0-.852q.564 0 .99-.419t.657-1.3.231-2.24c0-.905-.078-1.659-.231-2.232q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404q-.563 0-.983.404-.418.405-.657 1.264-.239.86-.239 2.232c0 .916.079 1.653.239 2.24q.238.881.657 1.3t.983.419M180.093 469.631v-.881h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.463-.166.838-.382h.809v8.337h1.922v.882h-5.101zM189.455 469.805q-1.359 0-2.131-1.25-.773-1.25-.773-3.562c0-1.541.258-2.731.773-3.54q.774-1.215 2.131-1.214c.905 0 1.628.408 2.138 1.222q.766 1.22.766 3.532t-.766 3.562-2.138 1.25m0-.852q.564 0 .99-.419t.657-1.3.231-2.24c0-.905-.078-1.659-.231-2.232q-.231-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404q-.563 0-.983.404-.418.405-.657 1.264-.239.86-.239 2.232c0 .916.079 1.653.239 2.24q.238.881.657 1.3t.983.419M193.718 469.631v-.881h2.124v-7.008h-1.676v-.679a6 6 0 0 0 1.084-.267q.463-.166.838-.382h.809v8.337h1.922v.882h-5.101zM203.081 469.805q-1.359 0-2.131-1.25-.773-1.25-.773-3.562c0-1.541.258-2.731.773-3.54q.774-1.215 2.131-1.214c.905 0 1.628.408 2.138 1.222q.765 1.22.766 3.532 0 2.313-.766 3.562-.767 1.25-2.138 1.25m0-.852q.564 0 .99-.419.425-.419.657-1.3.231-.882.231-2.24c0-.905-.078-1.659-.231-2.232q-.232-.86-.657-1.264a1.4 1.4 0 0 0-.99-.404q-.563 0-.983.404-.418.405-.657 1.264-.239.86-.239 2.232c0 .916.079 1.653.239 2.24q.238.881.657 1.3t.983.419"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__C)",
    d: "M255.862 390.579c-26.111-7.122-48.305-18.52-65.964-33.88-14.512-12.623-25.895-27.824-33.829-45.177-12.378-27.071-12.375-51.045-12.221-56.021v-80.394c0-13.878 12.166-24.615 25.937-22.888h.003c.195.025 20.259 2.487 40.978 2.487 3.439 0 6.735-.067 9.795-.2 13.557-.589 26.105-7.749 33.566-19.152l1.135-1.732c3.15-4.807 10.195-4.806 13.342.002l1.133 1.73c7.462 11.404 20.009 18.563 33.565 19.152 3.06.133 6.356.2 9.796.2 20.678 0 40.791-2.463 40.993-2.488 13.765-1.719 25.923 9.013 25.925 22.885V255.5c.155 4.975.158 28.949-12.221 56.022-7.935 17.353-19.317 32.552-33.829 45.177-17.659 15.36-39.853 26.759-65.964 33.88l-6.07 1.656z",
    opacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__D)",
    d: "M370.721 255.65zv-80.544c0-8.284-7.26-14.693-15.481-13.665h-.003c-.205.026-20.739 2.559-42.139 2.559-3.728 0-7.118-.076-10.199-.21-12.64-.548-24.485-5.73-33.434-14.308a10.9 10.9 0 0 0-7.534-3.041 10.9 10.9 0 0 0-7.534 3.041c-8.95 8.577-20.793 13.759-33.433 14.308-3.081.134-6.471.21-10.199.21-21.402 0-41.933-2.533-42.135-2.559-8.222-1.032-15.488 5.38-15.488 13.668v80.542c-.126 3.659-.367 26.314 11.379 52.005 7.381 16.14 17.971 30.281 31.477 42.028 16.595 14.435 37.559 25.177 62.309 31.927 2.373.647 4.875.647 7.248 0 24.75-6.75 45.714-17.492 62.309-31.927 13.506-11.747 24.096-25.888 31.476-42.028 11.748-25.693 11.506-48.349 11.38-52.006"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__E)",
    d: "M226.718 177.654a206 206 0 0 1-8.696.177c-18.367 0-35.984-2.175-36.158-2.196l-4.501-.565c-4.667-.585-8.791 3.053-8.791 7.758v73.653c-.108 3.14-.314 22.581 9.765 44.629 6.334 13.85 15.422 25.985 27.013 36.067 14.24 12.387 32.231 21.604 53.471 27.398l3.11.847V157.579c-7.828 11.963-20.928 19.458-35.213 20.075"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__F)",
    d: "M355.291 256.481v-69.117l-.002-8.521a4.3 4.3 0 0 0-4.832-4.265l-8.455 1.055c-.176.023-17.798 2.195-36.161 2.198-3.177 0-6.068-.063-8.696-.177a44.2 44.2 0 0 1-20.028-5.783 44.5 44.5 0 0 1-15.186-14.292v207.843l3.11-.847c21.239-5.792 39.231-15.011 53.471-27.398 11.591-10.082 20.679-22.217 27.013-36.067 10.081-22.049 9.873-41.492 9.765-44.629z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CAD5FC",
    opacity: 0.62,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M298.167 264.784v-.947h2.281v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287q.496-.18.899-.411h.869v8.952h2.064v.947zM308.221 264.971q-1.459 0-2.289-1.342t-.829-3.824c0-1.655.276-2.933.829-3.801q.83-1.304 2.289-1.304c.973 0 1.747.437 2.297 1.312q.822 1.311.821 3.794 0 2.482-.821 3.824-.823 1.342-2.297 1.342zm0-.915q.605 0 1.063-.451.457-.449.706-1.396.247-.946.247-2.404c0-.972-.083-1.781-.247-2.397q-.249-.923-.706-1.358a1.5 1.5 0 0 0-1.063-.434q-.605 0-1.055.434-.449.435-.706 1.358-.256.924-.255 2.397c0 .981.085 1.774.255 2.404q.257.947.706 1.396.45.451 1.055.451M312.798 264.784v-.947h2.281v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287q.496-.18.899-.411h.869v8.952h2.064v.947zM322.852 264.971q-1.459 0-2.289-1.342t-.83-3.824c0-1.655.277-2.933.83-3.801q.83-1.304 2.289-1.304c.972 0 1.747.437 2.296 1.312q.823 1.311.822 3.794 0 2.482-.822 3.824t-2.296 1.342zm0-.915q.604 0 1.063-.451.458-.449.705-1.396.249-.946.248-2.404c0-.972-.083-1.781-.248-2.397q-.247-.923-.705-1.358a1.5 1.5 0 0 0-1.063-.434q-.606 0-1.055.434-.45.435-.706 1.358-.256.924-.255 2.397c0 .981.085 1.774.255 2.404q.256.947.706 1.396a1.44 1.44 0 0 0 1.055.451M327.429 264.784v-.947h2.281v-7.524h-1.801v-.73a6.6 6.6 0 0 0 1.164-.287 5.7 5.7 0 0 0 .9-.411h.869v8.952h2.064v.947zM337.483 264.971q-1.459 0-2.289-1.342t-.83-3.824c0-1.655.277-2.933.83-3.801q.83-1.304 2.289-1.304c.972 0 1.747.437 2.296 1.312q.822 1.311.822 3.794t-.822 3.824-2.296 1.342zm0-.915q.605 0 1.062-.451.458-.449.706-1.396t.248-2.404c0-.972-.083-1.781-.248-2.397q-.248-.923-.706-1.358a1.5 1.5 0 0 0-1.062-.434q-.605 0-1.055.434-.45.435-.706 1.358-.256.924-.256 2.397c0 .981.086 1.774.256 2.404q.256.947.706 1.396a1.44 1.44 0 0 0 1.055.451M298.167 283.402v-.947h2.281v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287q.496-.18.899-.411h.869v8.952h2.064v.947zM308.221 283.589q-1.459 0-2.289-1.342t-.829-3.824c0-1.655.276-2.933.829-3.801q.83-1.303 2.289-1.303c.973 0 1.747.436 2.297 1.311q.822 1.311.821 3.794 0 2.482-.821 3.824-.823 1.342-2.297 1.342zm0-.915q.605 0 1.063-.451.457-.449.706-1.396.247-.946.247-2.404c0-.972-.083-1.781-.247-2.397q-.249-.923-.706-1.358a1.5 1.5 0 0 0-1.063-.434q-.605 0-1.055.434t-.706 1.358-.255 2.397c0 .982.085 1.774.255 2.404q.257.947.706 1.396.45.451 1.055.451M312.798 283.402v-.947h2.281v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287q.496-.18.899-.411h.869v8.952h2.064v.947zM322.852 283.589q-1.459 0-2.289-1.342t-.83-3.824c0-1.655.277-2.933.83-3.801q.83-1.303 2.289-1.303c.972 0 1.747.436 2.296 1.311q.823 1.311.822 3.794 0 2.482-.822 3.824t-2.296 1.342zm0-.915q.604 0 1.063-.451.458-.449.705-1.396.249-.946.248-2.404c0-.972-.083-1.781-.248-2.397q-.247-.923-.705-1.358a1.5 1.5 0 0 0-1.063-.434q-.606 0-1.055.434-.45.434-.706 1.358t-.255 2.397c0 .982.085 1.774.255 2.404q.256.947.706 1.396a1.44 1.44 0 0 0 1.055.451M327.429 283.402v-.947h2.281v-7.524h-1.801v-.73a6.6 6.6 0 0 0 1.164-.287 5.7 5.7 0 0 0 .9-.411h.869v8.952h2.064v.947zM337.483 283.589q-1.459 0-2.289-1.342t-.83-3.824c0-1.655.277-2.933.83-3.801q.83-1.303 2.289-1.303c.972 0 1.747.436 2.296 1.311q.822 1.311.822 3.794t-.822 3.824-2.296 1.342zm0-.915q.605 0 1.062-.451.458-.449.706-1.396t.248-2.404c0-.972-.083-1.781-.248-2.397q-.248-.923-.706-1.358a1.5 1.5 0 0 0-1.062-.434q-.605 0-1.055.434t-.706 1.358-.256 2.397c0 .982.086 1.774.256 2.404q.256.947.706 1.396a1.44 1.44 0 0 0 1.055.451M342.059 283.402v-.947h2.28v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287 5.7 5.7 0 0 0 .9-.411h.869v8.952h2.063v.947zM298.167 302.02v-.947h2.281v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287q.496-.18.899-.411h.869v8.952h2.064v.947zM308.221 302.207q-1.459 0-2.289-1.342t-.829-3.824c0-1.655.276-2.933.829-3.801q.83-1.303 2.289-1.303c.973 0 1.747.436 2.297 1.311q.822 1.311.821 3.794 0 2.482-.821 3.824-.823 1.342-2.297 1.342zm0-.916q.605 0 1.063-.451.457-.449.706-1.396.247-.946.247-2.404c0-.972-.083-1.781-.247-2.397q-.249-.923-.706-1.358a1.5 1.5 0 0 0-1.063-.434q-.605 0-1.055.434-.449.435-.706 1.358-.256.924-.255 2.397c0 .981.085 1.774.255 2.404q.257.947.706 1.396.45.451 1.055.451M312.798 302.02v-.947h2.281v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287q.496-.18.899-.411h.869v8.952h2.064v.947zM322.852 302.207q-1.459 0-2.289-1.342t-.83-3.824c0-1.655.277-2.933.83-3.801q.83-1.303 2.289-1.303c.972 0 1.747.436 2.296 1.311q.823 1.311.822 3.794 0 2.482-.822 3.824t-2.296 1.342zm0-.916q.604 0 1.063-.451.458-.449.705-1.396.249-.946.248-2.404c0-.972-.083-1.781-.248-2.397q-.247-.923-.705-1.358a1.5 1.5 0 0 0-1.063-.434q-.606 0-1.055.434-.45.435-.706 1.358-.256.924-.255 2.397c0 .981.085 1.774.255 2.404q.256.947.706 1.396a1.44 1.44 0 0 0 1.055.451M327.429 302.02v-.947h2.281v-7.524h-1.801v-.73a6.6 6.6 0 0 0 1.164-.287 5.7 5.7 0 0 0 .9-.411h.869v8.952h2.064v.947zM337.483 302.207q-1.459 0-2.289-1.342t-.83-3.824c0-1.655.277-2.933.83-3.801q.83-1.303 2.289-1.303c.972 0 1.747.436 2.296 1.311q.822 1.311.822 3.794t-.822 3.824-2.296 1.342zm0-.916q.605 0 1.062-.451.458-.449.706-1.396t.248-2.404c0-.972-.083-1.781-.248-2.397q-.248-.923-.706-1.358a1.5 1.5 0 0 0-1.062-.434q-.605 0-1.055.434-.45.435-.706 1.358-.256.924-.256 2.397c0 .981.086 1.774.256 2.404q.256.947.706 1.396a1.44 1.44 0 0 0 1.055.451M342.059 302.02v-.947h2.28v-7.524h-1.8v-.73a6.6 6.6 0 0 0 1.164-.287 5.7 5.7 0 0 0 .9-.411h.869v8.952h2.063v.947zM352.112 302.207q-1.459 0-2.289-1.342t-.83-3.824c0-1.655.277-2.933.83-3.801q.83-1.303 2.289-1.303c.972 0 1.747.436 2.296 1.311q.822 1.311.822 3.794t-.822 3.824-2.296 1.342zm0-.916q.604 0 1.062-.451.458-.449.706-1.396.249-.946.248-2.404c0-.972-.084-1.781-.248-2.397q-.248-.923-.706-1.358a1.5 1.5 0 0 0-1.062-.434q-.606 0-1.055.434-.45.435-.706 1.358-.256.924-.256 2.397c0 .981.086 1.774.256 2.404q.256.947.706 1.396a1.44 1.44 0 0 0 1.055.451"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00FFA3",
    strokeMiterlimit: 10,
    strokeWidth: 1.077,
    d: "M261.932 353.17c85.53-23.326 81.537-96.458 81.537-96.458v-69.348s-70.399 8.826-81.537-8.196c-11.139 17.022-81.538 8.196-81.538 8.196v69.348s-3.993 73.132 81.538 96.458Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__G)",
    d: "M288.413 253.719v-3.961c0-14.601-11.879-26.48-26.48-26.48s-26.481 11.879-26.481 26.48v3.961a6.19 6.19 0 0 0-5.933 6.186v39.061a6.193 6.193 0 0 0 6.192 6.193h52.446a6.193 6.193 0 0 0 6.192-6.193v-39.061a6.19 6.19 0 0 0-5.933-6.186zm-26.481-22.445c10.192 0 18.484 8.293 18.484 18.484v3.955h-36.969v-3.955c0-10.192 8.292-18.484 18.484-18.484z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBFE",
    d: "M235.709 248.304h52.445a6.195 6.195 0 0 1 6.192 6.192v39.061a6.195 6.195 0 0 1-6.192 6.191h-52.445a6.194 6.194 0 0 1-6.191-6.191v-39.061a6.195 6.195 0 0 1 6.191-6.192"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBFE",
    d: "M284.415 256.3a4 4 0 0 1-3.998-3.997v-7.953c0-10.192-8.292-18.484-18.484-18.484-10.191 0-18.484 8.293-18.484 18.484v7.953a3.998 3.998 0 0 1-7.995 0v-7.953c0-14.601 11.879-26.48 26.48-26.48s26.481 11.879 26.481 26.48v7.953a4 4 0 0 1-3.998 3.997z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HealthCare_svg__H)",
    d: "M257.969 283.835a2.4 2.4 0 0 1-1.697-.702l-6.893-6.893a2.398 2.398 0 1 1 3.392-3.393l5.197 5.197 13.124-13.124a2.4 2.4 0 1 1 3.393 3.393l-14.821 14.82a2.4 2.4 0 0 1-1.696.702z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__b",
    x1: 739.21,
    x2: -73.511,
    y1: 158.343,
    y2: 409.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ABA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__c",
    x1: 582.437,
    x2: 36.673,
    y1: 192.228,
    y2: 361.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ABA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__d",
    x1: 192.479,
    x2: 279.997,
    y1: 143.429,
    y2: 292.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__e",
    x1: 534.626,
    x2: 516.332,
    y1: 233.194,
    y2: 174.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__f",
    x1: 80.053,
    x2: 45.346,
    y1: 306.367,
    y2: 210.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__g",
    x1: 363.097,
    x2: 332.362,
    y1: 528.077,
    y2: 442.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__h",
    x1: 89.445,
    x2: 212.182,
    y1: 112.887,
    y2: 112.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__i",
    x1: 451.765,
    x2: 441.151,
    y1: 295.719,
    y2: 263.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__j",
    x1: 454.879,
    x2: 432.566,
    y1: 313.993,
    y2: 259.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__k",
    x1: 168.654,
    x2: 151.669,
    y1: 406.643,
    y2: 394.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__l",
    x1: 161.937,
    x2: 153.794,
    y1: 402.58,
    y2: 386.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__m",
    x1: 168.654,
    x2: 151.669,
    y1: 396.809,
    y2: 384.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__n",
    x1: 161.937,
    x2: 153.794,
    y1: 392.745,
    y2: 377.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__o",
    x1: 168.654,
    x2: 151.669,
    y1: 386.974,
    y2: 374.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__p",
    x1: 161.937,
    x2: 153.794,
    y1: 382.91,
    y2: 367.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__q",
    x1: 146.629,
    x2: 144.727,
    y1: 418.474,
    y2: 404.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__r",
    x1: 144.164,
    x2: 136.021,
    y1: 413.337,
    y2: 397.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__s",
    x1: 146.629,
    x2: 144.727,
    y1: 408.639,
    y2: 394.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__t",
    x1: 144.164,
    x2: 136.021,
    y1: 403.504,
    y2: 387.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__u",
    x1: 146.629,
    x2: 144.727,
    y1: 398.804,
    y2: 384.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__v",
    x1: 144.164,
    x2: 136.021,
    y1: 393.669,
    y2: 377.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__w",
    x1: 160.287,
    x2: 153.209,
    y1: 402.384,
    y2: 389.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#305EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3765ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4370F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5481F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6A96F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__x",
    x1: 162.221,
    x2: 155.144,
    y1: 401.328,
    y2: 388.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#305EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3765ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4370F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5481F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6A96F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__y",
    x1: 301.719,
    x2: 293.513,
    y1: 90.257,
    y2: 67.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__z",
    x1: 305.987,
    x2: 300.873,
    y1: 79.472,
    y2: 52.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__A",
    x1: 307.535,
    x2: 302.544,
    y1: 103.565,
    y2: 76.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__B",
    x1: 372.529,
    x2: 363.498,
    y1: 376.568,
    y2: 351.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__C",
    x1: 244.949,
    x2: 286.237,
    y1: 130.319,
    y2: 349.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__D",
    x1: 460.705,
    x2: 117.714,
    y1: 217.902,
    y2: 315.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ABA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__E",
    x1: 219.627,
    x2: 47.106,
    y1: 159.043,
    y2: 442.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__F",
    x1: 313.011,
    x2: 140.49,
    y1: 159.043,
    y2: 442.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__G",
    x1: 305.909,
    x2: 227.393,
    y1: 382.273,
    y2: 198.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#305EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3765ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4370F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5481F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6A96F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthCare_svg__H",
    x1: 270.95,
    x2: 258.63,
    y1: 291.709,
    y2: 262.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#305EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3765ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4370F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5481F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6A96F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "HealthCare_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .214h564v522.572H0z"
  })))));
};
export default SvgHealthCare;